import Button from "components/ui/Button";
import InputDatePicker from "components/ui/forms/InputDatePicker";
import InputField from "components/ui/forms/InputField";
import InputSelect from "components/ui/forms/InputSelect";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const BetHistoryFilters = ({ setSelectedFilters, handleFilters }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    //console.log(data, "data");
    handleFilters(data);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const BET_TYPE_OPTIONS = [
    { value: "all", label: "All" },
    { value: "single", label: "Single" },
    { value: "multiple", label: "Miltiple" },
    { value: "system", label: "System" },
    { value: "chain", label: "Chain" },
    { value: "betBuilder", label: "Bet Builder" },
  ];
  const PERIOD_OPTIONS = [
    { value: "24", label: "24 hours" },
    { value: "72", label: "72 hours" },
    { value: "oneWeek", label: "One week" },
    { value: "oneMonth", label: "30 Days" },
    { value: "custom", label: "Custom" },
  ];

  useEffect(() => {
    setValue("betType", BET_TYPE_OPTIONS[0]);
    setValue("period", PERIOD_OPTIONS[0]);
    setSelectedFilters(getValues());
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <div className="md:flex gap-2 md:space-y-0 space-y-1">
        <InputField
          name="betId"
          label="Bet ID"
          control={control}
          {...register("betId")}
        />
        <InputField
          name="sportName"
          label="Sport Name"
          control={control}
          {...register("sportName")}
          postfix={<i className="bc-i-search" />}
        />
        <InputSelect
          // multiple
          label="Bet Type"
          name="betType"
          // defaultValue={BET_TYPE_OPTIONS[0]}
          options={BET_TYPE_OPTIONS}
          control={control}
          {...register("betType")}
        />
        <InputSelect
          label="Period"
          name="period"
          // defaultValue={PERIOD_OPTIONS[4]}
          options={PERIOD_OPTIONS}
          control={control}
          {...register("period")}
        />
        {watch("period")?.value === "custom" && (
          <>
            <InputDatePicker
              selectsStart
              label="Range"
              placeholderText="From"
              name="fromDate"
              control={control}
              {...register("fromDate")}
              selected={watch("fromDate")}
              startDate={watch("fromDate")}
              endDate={watch("toDate")}
              maxDate={watch("toDate") ? watch("toDate") : new Date()}
              onChange={(date) => {
                setValue("fromDate", date);
              }}
            />
            <InputDatePicker
              selectsEnd
              placeholderText="To"
              name="toDate"
              control={control}
              selected={watch("toDate")}
              startDate={watch("fromDate")}
              endDate={watch("toDate")}
              minDate={watch("fromDate")}
              maxDate={new Date()}
              {...register("toDate")}
              onChange={(date) => {
                setValue("toDate", date);
              }}
            />
          </>
        )}
      </div>
      <div className="pt-5">
        <Button
          label={isLoading ? "Logging in..." : "Show"}
          type="submit"
          size="small"
          variant="green"
          className="uppercase md:max-w-[200px] w-full ml-auto"
        />
      </div>
    </form>
  );
};

export default BetHistoryFilters;
